import React, { Component } from 'react';
import {
  Container,
  Row,
  Col
} from 'reactstrap';

class StepBar extends Component {
  render () {
    const { step, business } = this.props;
    let businessUrl = "#";
    
    if(business)
      businessUrl = "/discover_unifying_factors/business/" + business; 

    return (
      <Container fluid={true} className="sl-step-shell">
        <Row>
          <Col md="12">
            <div className="step-indicator">
              <p 
                className={step >= 1 ? "step completed" : "step"}
                onClick={() => window.location = "/discover_unifying_factors/index"}>
                1. Select a Business
              </p>
              <p 
                className={step >= 2 ? "step completed" : "step"}
                onClick={() => window.location = businessUrl}>
                2. Select Prefecture
              </p>
              <p 
                className={step >= 3 ? "step completed" : "step"}>
                3. Explore Prefecture Data
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    );
  }
}

export default StepBar;

